import React, { HTMLInputTypeAttribute, useState } from 'react';
import Input, { InputProps } from './Input';
import { ReactComponent as Eye } from '../../../assets/icons/eye.svg';
import { ReactComponent as EyeCrossed } from '../../../assets/icons/eye-crossed.svg';

function InputPassword(props: InputProps) {
  const [ type, setType ] = useState<HTMLInputTypeAttribute>('password');

  let Icon = Eye;
  if (type === 'password') {
    Icon = EyeCrossed;
  }

  return (
    <Input
      {...props}
      type={type}
      icon={<Icon width={'1.5rem'} height={'1.5rem'}/>}
      iconAction={() => setType(type === 'password' ? 'string' : 'password')}
    />
  )
}

export default InputPassword;
